export enum AlertCondition {
    SPEEDING = 'SPEEDING',
    ENTERING_AREA = 'ENTERING_AREA',
    LEAVING_AREA = 'LEAVING_AREA'
}
export enum Priority {
    LOW = 'LOW',
    MEDIUM = 'MEDIUM',
    HIGH = 'HIGH'
}

export enum DomainOfIntrestType {
    POI = 'POI',
    AREA = 'AREA'
}

export enum CarEvent {
    CAR_TOW = 'CAR_TOW',
    CAR_COLLISION = 'CAR_COLLISION',
    EU_BORDER_CLOSENESS = 'EU_BORDER_CLOSENESS'
}



// WEBPACK FOOTER //
// ./src/Models/EnumTypes/AlertEnumTypes.ts